import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Staff } from '@wsphere/staff/domain';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class CustomRolesService {
  constructor(private http: HttpClient) {}

  async list() {
    return await firstValueFrom(this.http.get<Staff.Security.CustomRole[]>(`/api/custom-roles`));
  }

  async retrieve(customRoleId: string) {
    return await firstValueFrom(this.http.get<Staff.Security.CustomRole>(`/api/custom-roles/${customRoleId}`));
  }

  async update(customRoleId: string, dto: Staff.Security.UpdateCustomRoleRequest) {
    return await firstValueFrom(
      this.http.patch<Staff.Security.UpdateCustomRoleResponse>(`/api/custom-roles/${customRoleId}`, dto)
    );
  }
}
